<template>
    <div class="nav-btn-container">
        <div class="nav-btn left">
            <div  class="md-container">
                <a type="button" class="nav-btn-left" @click="about_route()"><span>ABOUT US</span></a>
                <span class="nav-btn-left" style="margin: 0 25px;"> | </span>
                <a type="button" class="nav-btn-left"><span style="color: #868e96; cursor: default;" v-on:click="$emit('app')">OUR APP</span></a>
            </div>
        </div>
        <div class="nav-btn center">
            <img class="re-logo" @click="home_route()" :src="require('../assets/Desktop/Home_Landing/RE-Logo-Light.png')" alt="">
        </div>
        <div class="nav-btn right">
            <a style="display:none;">
                <span>SIGN UP</span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                home_r: {},
                about_r: {},
            }
        },
        mounted() {
            if (this.$route.query.ref) {
                this.home_r = {'name': 'Home', 'query': { ref: this.$route.query.ref }}
                this.about_r = {'name': 'About', 'query': { ref: this.$route.query.ref }}
            } else {
                this.home_r = {'name': 'Home'}
                this.about_r = {'name': 'About'}
            }
        },
        methods: {
            home_route: function(e) {
                this.$router.push(this.home_r)
            },
            about_route: function(e) {
                this.$router.push(this.about_r)
            }
        }
    }
</script>

<style scoped>
    .center {
        text-align: center;
    }

    .nav-btn-container {
        padding-top: 45px;
        background-color: transparent;
        text-align: center;
        z-index:3;
    }

    .re-logo {
        cursor: pointer;
    }

    .nav-btn {
        background-color: transparent;
        z-index: 2;
        display: inline-block;
        z-index: 100;
        width: 30%;
        margin: 0px;
        padding: 0px;
        font-family: Oswald;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 3.67px;
        line-height: 15px;
        vertical-align: bottom;
    }

    .nav-btn-left {
        height: 61px;
        color: #FFFFFF;
        background-color: Transparent;
        background-repeat: no-repeat;
        border: none;
        cursor:pointer;
        overflow: hidden;
    }

    .nav-btn-left > span {
        cursor: pointer;
        color: #FFFFFF;
        font-family: Oswald;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 1.44px;
        line-height: 61px;
        text-align: right;
        background: transparent;
    }

    .nav-btn > div {
        display: inline-block;
    }

    .right > a {
        cursor: pointer;
        display: inline-block;
        width: 147px;
        padding: 12px;
        margin: 10.5px 180px 0 0;
        border: 1px solid #B01C1E;
        background-color: #9B111E;
    }

    .right > a > span {
        vertical-align: middle;
        width: 100%;
        color: #FFFFFF;
        font-family: Oswald;
        font-size: 11px;
        font-weight: 400;
        letter-spacing: 3.67px;
        line-height: 15px;
    }

    .right {
        margin: auto 0;
        height: 63px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Nav_Bar.vue